/* eslint-disable react-hooks/exhaustive-deps */
import { EmptyData } from '@/components/lib/EmptyData'
import { Loading } from '@/components/lib/Loading'
import { OrderType } from '@/types/OrderType'
import { getStatusBadge, setDateTime, setOrderStatus } from '@/utils/Functions'
import { Card, Col, Container, Row, Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import OrderDropMenu from './OrderDropMenu'
import OrderFilter from './OrderFilter'
import HEADER_TAB from '@/data/orderTableHeader.json'
import useOrder from '@/hooks/use-order'
import useMediaQuery from '@/hooks/use-media-query'

const MD_BREAKPOINT = '(min-width: 769px)'
// const MD_BREAKPOINT = '(min-width: 769px)';

export const OrderListTable = () => {
  const {
    barcode,
    status,
    setStatus,
    orders,
    loading,
    loadSpinner,
    nextPage,
    prevPage,
    perPageOptions,
    totalPages,
    currentPage,
    perPage,
    getPages,
    goToPage,
    handlePerPageChange,
    handleUpdateStatus,
    handleDelete,
    handleSendNotification,
    handleBarcodeChange,
    handleFilter,
    handleReset,
  } = useOrder()
  const isDesktop = useMediaQuery(MD_BREAKPOINT)

  /* PaginationComponent Component
   *******************************************************************************************/
  const PaginationComponent = () => {
    const pages = getPages(currentPage, totalPages)

    return (
      <div className='ms-auto p-3'>
        <nav aria-label='Page navigation example'>
          <ul className='pagination'>
            <li className='page-item'>
              <button
                className='page-link'
                disabled={!prevPage}
                onClick={() => goToPage(currentPage - 1)}
              >
                <span aria-hidden='true'>&laquo;</span>
              </button>
            </li>
            {pages.map((page, index) => (
              <li key={index} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                {page === '...' ? (
                  <span className='page-link'>...</span>
                ) : (
                  <button className='page-link' onClick={() => goToPage(Number(page))}>
                    {page}
                  </button>
                )}
              </li>
            ))}
            <li className='page-item'>
              <button
                className='page-link'
                disabled={!nextPage}
                onClick={() => goToPage(currentPage + 1)}
              >
                <span aria-hidden='true'>&raquo;</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    )
  }

  const PerPageSelector = () => (
    <select
      className='py-2 bg-transparent select-per-page px-2'
      value={perPage}
      onChange={handlePerPageChange}
    >
      {perPageOptions.map((option) => (
        <option key={option} value={option}>
          {option} par page
        </option>
      ))}
    </select>
  )
  {
    /* List Table desktop view */
  }
  const desktopTable = () => (
    <Table striped hover responsive>
      <thead>
        <tr>
          {HEADER_TAB.map((header) => (
            <th key={header.id}>{header.value}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {orders.map((order: OrderType) => (
          <tr key={order?.id}>
            <td>
              <Link to={'/livraisons/detail/' + order?.id}>{order?.id}</Link>
            </td>
            <td>
              <Link to={'/livraisons/detail/' + order?.id}>{order?.company?.name}</Link>
            </td>
            <td>
              <Link to={'/livraisons/detail/' + order?.id}>
                {order?.locker?.location}
                <br />
                <small className='text-muted'>{order?.locker?.shortLocation}</small>
              </Link>
            </td>
            <td>
              <Link to={'/livraisons/detail/' + order?.id}>{order?.barcode}</Link>
            </td>
            <td>
              <Link to={'/livraisons/detail/' + order?.id}>
                {order?.multiOrderCode ? order?.multiOrderCode : '-'}
              </Link>
            </td>
            <td>
              {order?.status === 'operin' ||
              order?.status === 'reminder' ||
              order?.status === 'overtimedue' ||
              order?.status === 'overtime' ? (
                <Link to={'/livraisons/detail/' + order?.id}>
                  {order?.cleveronSlotId ? order?.cleveronSlotId : '-'}
                </Link>
              ) : (
                '-'
              )}
            </td>
            <td>
              <Link to={'/livraisons/detail/' + order?.id}>
                {setOrderStatus(order?.status)}
              </Link>
            </td>
            <td>
              <Link to={'/livraisons/detail/' + order?.id}>
                {setDateTime(order?.createdAt)}
              </Link>
            </td>
            <td>
              <OrderDropMenu
                order={order}
                handleUpdateStatus={handleUpdateStatus}
                handleSendNotification={handleSendNotification}
                handleDelete={handleDelete}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
  {
    /* List Table mobile view */
  }
  const mobileListOrder = () => (
    <Container fluid className='d-flex flex-column justify-content-center  px-0'>
      {orders.map((order) => {
        const isOperin =
          order?.status === 'operin' ||
          order?.status === 'reminder' ||
          order?.status === 'overtimedue' ||
          order?.status === 'overtime'
        return (
          <Card
            key={order.id}
            className=' border-4 border-start border-dark px-0 ps- py-3 mb-2 w-100'
          >
            <div className='d-flex align-items-center gap-0'>
              <Col xs={3} className='ps-2'>
                <Link to={`/livraisons/detail/${order.id}`}>
                  <div className='d-flex flex-column'>
                    <div className='font-75 mb-2'>#{order.id}</div>
                    {order.multiOrderCode && (
                      <div className='font-65'>MOC: {order.multiOrderCode}</div>
                    )}
                  </div>
                </Link>
              </Col>
              <Col xs={6} className='d-flex flex-column justify-content-center'>
                <Link to={`/livraisons/detail/${order.id}`}>
                  <div className='d-flex flex-column justify-content-center align-items-center'>
                    <span className='mb-2'>
                      {order && order.status && getStatusBadge(order.status)}
                    </span>
                    <span className='text-center font-75'>{order.barcode}</span>
                    <span className='text-center font-75 '>
                      {isOperin && <>Slot: {order.cleveronSlotId}</>}
                    </span>
                  </div>
                </Link>
              </Col>
              <Col xs={3} className='text-end pe-2'>
                <OrderDropMenu
                  order={order}
                  handleUpdateStatus={handleUpdateStatus}
                  handleSendNotification={handleSendNotification}
                  handleDelete={handleDelete}
                />
              </Col>
            </div>
          </Card>
        )
      })}
    </Container>
  )

  const orderFilterProps = {
    handleFilter,
    handleBarcodeChange,
    handleReset,
    barcode,
    statusOrder: status,
    setStatusOrder: setStatus,
    loadSpinner,
  }
  /* Render
   *******************************************************************************************/
  return (
    <>
      {/* Filter component */}
      <OrderFilter orderFilterProps={orderFilterProps} />
      <>
        {loading ? (
          <Loading />
        ) : orders?.length === 0 ? (
          <EmptyData />
        ) : (
          <>
            {isDesktop ? desktopTable() : mobileListOrder()}

            <Row className='ms-auto pe-5'>
              <Col className='col'>
                <PaginationComponent />
              </Col>
              <Col className='col'>
                <PerPageSelector />
              </Col>
            </Row>
          </>
        )}
      </>
    </>
  )
}
